Ext.define('SA.model.createimport.ColumnStepValidator', {
    constructor(model) {
        var hasOneFile = model.getTupleList().getTupleCount() === 1;

        this.model = model;
        this.errorList = new SA.model.createimport.ColumnStepErrorList({hasOneFile});
    },

    getColumnList() {
        return this.model.getColumnDefinitionList();
    },

    getErrors() {
        this.errors = this.errors || this.performValidations();

        return this.errors;
    },

    getTupleList() {
        return this.model.getTupleList();
    },

    hasErrors() {
        return !!this.getErrors().length;
    },

    performColumnNameValidations() {
        var validator = new SA.model.createimport.ColumnNameValidator(this.getColumnList());

        this.errorList.maybeAddError('FRIENDLY_NAME_DEFAULTED_NAME_CONFLICT', validator.hasFriendlyNameDefaultedNameConflicts());
        this.errorList.maybeAddError('DUPLICATE_FRIENDLY_NAMES', validator.hasDuplicateFriendlyNames());
    },

    performDataFormatValidations() {
        var Validator = SA.model.createimport.NumericDataValidator,
            wrapNames = names => names.map(name => `‘${name}’`),
            wrapNamesInError = ({fileName, headerNames}) => ({fileName, headerNames: wrapNames(headerNames)}),
            errors = Validator.getErrorsForTupleList(this.getTupleList()).map(wrapNamesInError);

        errors.forEach(error => this.errorList.addTplError('NON_NUMERIC_DATA', {tplData: error}));
    },

    performLocationFormatValidations() {
        var Validator = SA.model.createimport.LocationFormatValidator,
            errors = Validator.getErrorsForTupleList(this.getTupleList());

        errors.forEach(error => this.errorList.addTplError('MALFORMED_LOCATION', {tplData: error}));
    },

    performValidations() {
        var errorList = this.errorList,
            columnList = this.getColumnList(),
            tupleList = this.getTupleList();

        errorList.maybeAddError('COLUMN_WITHOUT_TYPE', columnList.some(column => !column.getType()));
        errorList.maybeAddError('DATA_COLUMN_WITHOUT_FORMAT', columnList.some(column => column.isDataColumn() && !column.getFormat()));
        errorList.maybeAddError('FILE_WITHOUT_DATA_COLUMNS', tupleList.some(tuple => tuple.getDataColumnCount() === 0));
        errorList.maybeAddError('FILE_WITHOUT_LOCATION_COLUMN', tupleList.some(tuple => tuple.getLocationColumnCount() === 0));
        errorList.maybeAddError('FILE_WITH_MULTIPLE_LOCATION_COLUMNS', tupleList.some(tuple => tuple.getLocationColumnCount() > 1));

        this.performColumnNameValidations();
        this.performLocationFormatValidations();
        this.performDataFormatValidations();

        return errorList.toArray();
    }
});